import { ILLUSTRATIONS } from '@constants/illustrations';
import type { CylinderStatus } from '@lib/api';

/**
 * The small cylinder beside a serial number (one shared SVG, fixed size so nothing shifts while it loads):
 * decorative, greyed out once the cylinder is out of circulation. `lg` for the cylinder's own header.
 */
export function CylinderThumb({ status, size = 'sm' }: { status: CylinderStatus; size?: 'sm' | 'lg' }) {
  const px = size === 'lg' ? 56 : 32;
  return (
    <span className={`cyl-thumb ${size === 'lg' ? 'is-lg' : ''} ${status === 'ACTIVE' ? '' : 'is-inactive'}`} aria-hidden="true">
      <img src={ILLUSTRATIONS.cylinderThumb} alt="" width={px} height={px} decoding="async" draggable={false} />
    </span>
  );
}
